import React, { ForwardedRef, ReactChildren } from 'react';
import { Dropdown } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';

interface Props {
  min: string|undefined,
  max: string|undefined,
  setMin: (min: string|undefined) => void,
  setMax: (max: string|undefined) => void,
}

const CustomToggle = React.forwardRef(
  (props: { children: ReactChildren, onClick: Function }, ref: ForwardedRef<any>) => {
    const {
      children,
      onClick,
    } = props;
    return (
      <a
        href="#"
        className="algolia-select__control bg-white search-price-dropdown"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          if (onClick) {
            onClick(e);
          }
        }}
      >
        <span className="algolia-select__value-container">
          <span className="algolia-select__placeholder text-search-gray">
            {children}
          </span>
        </span>
        <span className="algolia-select__indicator algolia-select__dropdown-indicator d-flex">
          <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-tj5bde-Svg">
            <path
              d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
            />
          </svg>
        </span>
      </a>
    );
  },
);

const CustomPriceFilter: React.FC<Props> = ({
  min,
  max,
  setMin,
  setMax,
}) => (
  <Dropdown>
    <Dropdown.Toggle as={CustomToggle} id="price-custom-toggle">
      Price
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <div className="d-flex align-items-center p-2 price-input-container">
        <div className="d-flex align-items-center">
          <CurrencyInput
            className="form-control w-25"
            id="min-price"
            name="minimum-price"
            aria-label="Minimum price."
            decimalsLimit={2}
            prefix="$"
            value={min}
            onValueChange={(value, name) => setMin(value)}
          />
          <small className="mx-2">TO</small>
          <CurrencyInput
            className="form-control w-25"
            id="max-price"
            name="maximum-price"
            aria-label="Maximum price."
            decimalsLimit={2}
            prefix="$"
            value={max}
            onValueChange={(value, name) => setMax(value)}
          />
        </div>
      </div>
    </Dropdown.Menu>
  </Dropdown>
);

export default CustomPriceFilter;
